module.exports = __webpack_public_path__ + "img/site.c1e88c4c.svg";